/**
 * Home page/Landing page
 */

/**
 * TODO:
 * - Refactor for responsive UI
 */

import { VStack } from "@chakra-ui/react";
import { MessageScreen } from "components";
import useAuth from "hooks/useAuth";
import React, { useEffect, useState } from "react";
import AnimatedPhone from "../components/home/AnimatedPhone";
import SurveyListUI from "../components/home/SurveyListUI";
import ThreeSteps from "../components/home/ThreeSteps";
import Welcome from "../components/home/Welcome";
import AddressFormModal from "components/forms/AddressForm";
import { useGetSurveysInfoQuery, useGetUserProfileQuery } from "queries";
import { useLocation } from "react-router-dom";

const HomePage = React.memo(() => {
  const { userDetails } = useAuth();
  const location = useLocation();
  const {
    data: surveysInfoRaw,
    refetch: refetchSurveys,
    dataUpdatedAt,
  } = useGetSurveysInfoQuery();
  // Normalize: handle both raw array and axios-wrapped response { data: [] }
  const surveysInfo: any[] | undefined = Array.isArray(surveysInfoRaw)
    ? surveysInfoRaw
    : Array.isArray(surveysInfoRaw?.data)
    ? surveysInfoRaw.data
    : undefined;
  const { refetch: refetchProfile, dataUpdatedAt: updateProfileData } =
    useGetUserProfileQuery();

  const [open, setOpen] = useState(false);

  const handleClose = (): void => {
    setOpen(false);
  };

  useEffect(() => {
    refetchSurveys();
    refetchProfile();
  }, [location]);

  useEffect(() => {
    if (
      surveysInfo?.[0]?.isCompleted === true &&
      userDetails?.googleAddress === false &&
      userDetails?.address === false
    ) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [surveysInfo, userDetails, dataUpdatedAt, location]);

  return (
    <>
      <AddressFormModal open={open} handleClose={handleClose} />
      {(userDetails?.isEligibilitySurveyDone as boolean) &&
      !(userDetails?.isEligible as boolean) ? (
        <MessageScreen
          message="Unfortunately you are not eligible to participate in this study at this time."
          alt="Not Eligible"
          src="https://assets8.lottiefiles.com/packages/lf20_rT9nRjagup.json"
        />
      ) : (
        <VStack>
          <Welcome />
          <AnimatedPhone />
          <ThreeSteps />
          <SurveyListUI />
        </VStack>
      )}
    </>
  );
});

HomePage.displayName = "HomePage";

export default HomePage;
